import createModel, { prop } from './lib/create_model';

const TeamAssistCitation = createModel({
  modelName: 'TeamAssistCitation',

  properties: {
    snippetId: prop(String),
    snippetName: prop(String),
  },
});

export default TeamAssistCitation;
